import { render } from "./StatuspagesDetails.vue?vue&type=template&id=511812cd&scoped=true"
import script from "./StatuspagesDetails.vue?vue&type=script&lang=js"
export * from "./StatuspagesDetails.vue?vue&type=script&lang=js"

import "./StatuspagesDetails.vue?vue&type=style&index=0&id=511812cd&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511812cd"]])

export default __exports__